<div [class.controls-hidden]="!controlsVisible" class="presentation-mode-container">
  <!-- Blurred background layer -->
  <div
    *ngIf="settings.blurredBackground && currentImage"
    [style.background-image]="'url(' + getImageUrl(currentImage) + ')'"
    class="blurred-background"
  ></div>

  <div #imageContainer (click)="onImageClick()" class="image-display">
    <div class="image-wrapper">
      <div
        *ngFor="let key of [imageTransitionKey]; trackBy: trackByFn"
        [class.fade-transition]="settings.animationType === 'fade'"
        [class.slide-transition]="settings.animationType === 'slide'"
        class="image-transition-container"
      >
        <img
          #imageElement
          *ngIf="currentImage"
          [alt]="currentImage.title || 'Image'"
          [class.dynamic-view]="settings.viewMode === 'dynamic'"
          [class.ken-burns-0]="settings.viewMode === 'dynamic' && kenBurnsVariant === 0"
          [class.ken-burns-1]="settings.viewMode === 'dynamic' && kenBurnsVariant === 1"
          [class.ken-burns-2]="settings.viewMode === 'dynamic' && kenBurnsVariant === 2"
          [class.ken-burns-3]="settings.viewMode === 'dynamic' && kenBurnsVariant === 3"
          [src]="getImageUrl(currentImage)"
          (error)="handleImageLoadError()"
          (load)="onImageLoaded()"
          (loadstart)="onImageStartLoading()"
          class="presentation-image"
        />
      </div>

      <!-- Video play button overlay -->
      <div
        *ngIf="currentImage?.videoFile"
        [attr.aria-label]="'Play video' | translate"
        (click)="visitImagePage(); $event.stopPropagation()"
        class="video-play-overlay"
      >
        <div class="video-play-button">
          <fa-icon icon="play"></fa-icon>
        </div>
      </div>
    </div>

    <!-- Loading indicators -->
    <div *ngIf="showImageDataLoader || showImageFileLoader" class="loading-indicator-container">
      <div class="presentation-loading-spinner">
        <div class="spinner-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div *ngIf="showImageDataLoader" class="loading-text">{{ "Loading image data..." | translate }}</div>
        <div *ngIf="showImageFileLoader && !showImageDataLoader" class="loading-text">
          {{ "Loading image..." | translate }}
        </div>
      </div>
    </div>

    <img *ngIf="nextImageData" [attr.aria-hidden]="true" [src]="getImageUrl(nextImageData)" class="preload-image" />
  </div>

  <astrobin-presentation-info-panel
    *ngIf="currentImage && (!isMobile || (isPaused && mobileControlsVisible))"
    [image]="currentImage"
    [showControls]="controlsVisible"
    (visitImage)="visitImagePage()"
    class="info-panel"
  >
  </astrobin-presentation-info-panel>

  <astrobin-presentation-controls
    [class.is-paused]="isPaused"
    [currentIndex]="currentIndex"
    [isPaused]="isPaused"
    (exit)="exitPresentation()"
    (next)="nextImage()"
    (playPause)="togglePlayPause()"
    (previous)="previousImage()"
    (settings)="toggleSettings()"
    class="controls"
    [@controlsFade]="controlsVisible && (!isMobile || mobileControlsVisible) ? 'visible' : 'hidden'"
  >
  </astrobin-presentation-controls>

  <astrobin-presentation-settings-dialog
    *ngIf="showSettings"
    [settings]="settings"
    (cancel)="showSettings = false"
    (save)="updateSettings($event)"
  >
  </astrobin-presentation-settings-dialog>

  <!-- Progress bar -->
  <div *ngIf="!isPaused" class="slide-progress-bar">
    <div
      [class.animating]="isAnimatingProgress"
      [style.animation-duration.ms]="settings.playbackSpeed * 1000"
      class="slide-progress-fill"
    ></div>
  </div>
</div>
